import { render, staticRenderFns } from "./switch-accounts.vue?vue&type=template&id=3dc8ea98&scoped=true"
import script from "./switch-accounts.vue?vue&type=script&lang=js"
export * from "./switch-accounts.vue?vue&type=script&lang=js"
import style0 from "./switch-accounts.vue?vue&type=style&index=0&id=3dc8ea98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8ea98",
  null
  
)

export default component.exports